module.exports = __webpack_public_path__ + "img/mail.5b576c7e.svg";